var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-buttons"},_vm._l((_vm.buttons),function(button,index){return _c('button',{key:index,class:{ selected: _vm.selectedButton === index },on:{"click":function($event){return _vm.selectButton(index)}}},[_vm._v(" "+_vm._s(button)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }